import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { Spinner } from 'react-bootstrap';
import 'react-bootstrap-table/dist/react-bootstrap-table.min.css';
import MUIDataTable from 'mui-datatables';
import { Container, Row, Col } from 'react-bootstrap';
import { MuiThemeProvider, createMuiTheme } from "@material-ui/core/styles";
import { mockTreatments } from '../mockDb';
import axios from 'axios';
const { parseCookies } = require('nookies');

const Treatments = () => {
    const history = useHistory();
    const [treatments, setTreatments] = useState([]);
    const [loading, setLoading] = useState(false);
    const cookies = parseCookies();

    //Recupero i dati dal db
    useEffect(() => {
        let mounted = true
        const fetch = async () => {
            const result = await axios.get(`${window.$apiEndpoint}/treatments/fetch`, {
                headers: {
                    "x-access-token": cookies.token
                }
            });
            try {
                if (mounted) {
                    setTreatments(result.data)
                }
            } catch (e) {
                console.log(e)
            }
            setLoading(true)
        }
        fetch();
        return () => {
            mounted = false
        }
    }, [cookies.token]);

    const theme = createMuiTheme({
        overrides: {
            MUIDataTableHeadCell: {
                root: {
                    fontFamily: "'Raleway', sans-serif",
                    fontWeight: '200',
                },
            },
            MuiIconButton: {
                root: {
                    color: 'grey',
                },
            },
            MuiTableCell: {
                body: {
                    backgroundColor: '#00968817',
                },
            },
            MUIDataTableHeadCell: {
                fixedHeader: {
                    fontFamily: "'Raleway', sans-serif",
                    fontWeight: '200',
                    backgroundColor: ' white',
                },
            },
            MuiButton: {
                root: {
                    fontFamily: "'Raleway', sans-serif",
                    fontWeight: '200',
                    backgroundColor: ' white',
                },
            },
            MuiTypography: {
                body2: {
                    fontFamily: "'Raleway', sans-serif",
                    fontWeight: '200',
                    backgroundColor: ' white',
                },
            },
            MuiMenuItem: {
                root: {
                    fontFamily: "'Raleway', sans-serif",
                    fontWeight: '200',
                    backgroundColor: ' white',
                },
            },
            MuiTableCell: {
                root: {
                    fontFamily: "'Raleway', sans-serif",
                    fontWeight: '400',
                },
            },
            MUIDataTableToolbar: {
                hover: {
                    color: '#616161',
                },
            },
        },
    });

    const columns = [
        {
            name: "name",
            label: "Nome",
            options: {
                customBodyRender: (value) => (value ? value.toUpperCase() : "")
            }
        },
        {
            name: "price",
            label: "Tariffa Oraria"
        },
        {
            name: "notes",
            label: "Note"
        }
    ];

    const options = {
        filter: false,
        selectableRows: false,
        rowsPerPage: 5,

        onRowClick: (rowData, rowMeta) => {
            // prendo l'oggetto reale cliccato
            const clicked = treatments[rowMeta.dataIndex];
            if (!clicked) return;

            const treatmentId = clicked.id;

            history.push('/update-treatment/' + treatmentId);
        },

        textLabels: {
            body: {
                noMatch: "Spiacenti, nessun record corrispondente trovato",
                toolTip: "Ordinare",
                columnHeaderTooltip: column => `Ordinare per ${column.label}`
            },
            pagination: {
                next: "Pagina successiva",
                previous: "Pagina Precedente",
                rowsPerPage: "Righe per pagina:",
                displayRows: "of",
            },
            toolbar: {
                search: "Cerca",
                downloadCsv: "Scarica CSV",
                print: "Stampa",
                viewColumns: "Vedi Colonne",
                filterTable: "Tabella dei filtri",
            },
            filter: {
                all: "Tutto",
                title: "FILTRI",
                reset: "RIPRISTINA",
            },
            viewColumns: {
                title: "Mostra colonne",
                titleAria: "Mostra / Nascondi colonne tabella",
            },
        }
    };

    return (
        <Container fluid>
            <Row>
                <Col xs={12}>
                    <div className="card border-left-warning mt-6 shadow h-100 py-2 px-4">
                        <span style={{ fontSize: "2vh", fontWeight: "400", marginTop: '2vh', }}>Lista Trattamenti</span>
                        <span style={{ fontSize: "1.2vh", fontWeight: "200" }}> Cliccando sulla righa si entra nel dettaglio del trattamento</span>
                        <div className="overflow-x-scroll lg:overflow-hidden">
                            {!loading ? <center><Spinner animation="border" /></center> :
                                <MuiThemeProvider theme={theme}>
                                    <MUIDataTable
                                        title={""}
                                        data={treatments}
                                        columns={columns}
                                        options={options}
                                    />
                                </MuiThemeProvider>
                            }
                        </div>
                    </div>
                </Col>
            </Row>
        </Container>
    )
}
export default Treatments;